module.exports = __webpack_public_path__ + "static/media/unlocked-right.f269a3bb.svg";